import styled from "@emotion/styled"
import { PIcon, PText } from "@porsche-design-system/components-react"
import { spacingStaticXs } from "@porsche-design-system/components-react/emotion"

export interface ValidationMessageProps {
	message: string
}

export const ValidationMessage = (props: ValidationMessageProps) => {
	const { message, ...rest } = props

	return (
		<Wrapper {...rest}>
			<PIcon color="error" name="exclamation" size="sm" />
			<PText color="error">{message}</PText>
		</Wrapper>
	)
}

const Wrapper = styled.div`
	display: flex;
	flex-wrap: nowrap;
	gap: ${spacingStaticXs};
`
